/**
 * Stable identifiers for the bottom-sheets and modals that the search-form
 * widget owns. Centralised so consumers (templates, handlers, tests) never
 * touch raw string literals.
 */
export const SHEET_IDS = {
  passengers: 'select-passengers-bottom-sheet',
  citiesFrom: 'select-cities-bottom-sheet-from',
  citiesTo: 'select-cities-bottom-sheet-to',
  calendar: 'search-form-calendar-bottom-sheet',
  errorModal: 'search-form-error-modal',
  multiTripInfo: 'multi-trip-info-bottom-sheet',
  animatedFlow: 'search-form-animated-flow-sheet',
} as const;

export type SheetId = (typeof SHEET_IDS)[keyof typeof SHEET_IDS];

export const MT_SESSION_KEY = 'free-avia:mt-session-active';
